<template>
  <DocumentsBrowserWireframe>
    <template #topbar-left>
      <BackButton :go-back="goBack" />
    </template>
    <template #topbar-center>
      <MediaTabs :tabs="tabs" :active-tab="activeTab" @on-change-tab="onChangeTab" />
    </template>
    <template #topbar-right>
      <div></div>
    </template>

    <template #details-left>
      <MediaDetails :headline="currentTabData.headline" :description="currentTabData.description" />
    </template>

    <template #search>
      <MediaSearchAndFilters v-if="currentTabData.displaySearch" />
    </template>

    <template #assets>
      <MediaList :tab-key="currentTabData.key" />
    </template>
  </DocumentsBrowserWireframe>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { useWesley } from '@anthill-modules/wesley-components';
import { useI18n } from 'vue-i18n';

import useModals from '~/composables/useModals';
import useFormFilters from '~/composables/useFormFilters';
import { MEDIA_TYPE } from '~/constants/documents';

import MediaDetails from '~/components/common/mediaPanel/MediaDetails.vue';
import DocumentsBrowserWireframe from '~/components/common/DocumentsBrowserWireframe.vue';
import BackButton from '~/components/common/BackButton.vue';
import MediaSearchAndFilters from '~/components/common/mediaPanel/MediaSearchAndFilters.vue';
import MediaList from '~/components/common/mediaPanel/MediaList.vue';
import MediaTabs from '~/components/common/mediaPanel/MediaTabs.vue';

export default defineComponent({
  components: { MediaSearchAndFilters, BackButton, MediaDetails, DocumentsBrowserWireframe, MediaList, MediaTabs },
  setup() {
    const { t } = useI18n();

    const { setMediaPanelOpened } = useModals();
    const { setSearchQuery } = useFormFilters();
    const { sendMessage: sendMessageToDocument } = useWesley();

    const tabs = [
      {
        name: t('author.media'),
        index: 1,
        key: MEDIA_TYPE.imported,
        displaySearch: true,
        headline: t('author.mediaSearch'),
        description: t('author.mediaSearchDescription'),
      },
      {
        name: t('author.userImages'),
        index: 2,
        key: MEDIA_TYPE.userImages,
        displaySearch: false,
        headline: t('author.userImages'),
      },
    ];

    const currentTabData = computed(() => tabs.find((tab) => tab.index === activeTab.value));

    const mediaAssets = ref([]);
    const activeTab = ref(tabs[0].index);

    const onChangeTab = (index) => {
      activeTab.value = index;
    };

    const goBack = () => {
      setMediaPanelOpened({ cssPath: '', opened: false });
      setSearchQuery('');
      sendMessageToDocument({ method: 'deselectElement' });
    };

    return {
      goBack,
      mediaAssets,
      tabs,
      activeTab,
      onChangeTab,
      currentTabData,
    };
  },
});
</script>

<style scoped lang="scss">
.dialog-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
</style>
